"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FileUploadField", {
  enumerable: true,
  get: function get() {
    return _FileUploadField["default"];
  }
});
Object.defineProperty(exports, "FileDownloadField", {
  enumerable: true,
  get: function get() {
    return _FileDownload["default"];
  }
});

var _FileUploadField = _interopRequireDefault(require("./FileUploadField"));

var _FileDownload = _interopRequireDefault(require("./FileDownload"));